import { render, staticRenderFns } from "./VoucherReport.vue?vue&type=template&id=87d58246&"
import script from "./VoucherReport.vue?vue&type=script&lang=js&"
export * from "./VoucherReport.vue?vue&type=script&lang=js&"
import style0 from "./VoucherReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports